export const TITLE = {
  pt: "Cadastro concluído!",
  es: "¡Registro finalizado!",
  en: "Signup complete!",
};

export const DESCRIPTION = {
  pt: "Enviamos um e-mail de verificação para você. Um administrador precisa liberar seu acesso antes do primeiro login.",
  es: "Le enviamos un correo de verificación. Un administrador deberá liberar su acceso antes del primer inicio de sesión.",
  en: "We sent you a verification e-mail. An admin needs to grant you access before the first login.",
};

export const BACK_TO_LOGIN = {
  pt: "Voltar ao login",
  es: "Volver al inicio de sesión",
  en: "Back to login",
};

export const BACK_TO_CPMS = {
  pt: "Voltar para o CPMS",
  es: "Volver al CPMS",
  en: "Back to CPMS",
};
